
import CreateMusicViewModel from "@models/music/createMusicViewModel";
import { COVER_IMAGE_RATIO } from "@/appSettings";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import MusicAudioViewModel from "@models/music/musicAudioViewModel";
import CategoryViewModel from "@models/categoryViewModel";

@Component
export default class CreateMusicComponent extends Vue {
  languages: string[] = [];
  isLoading = false;
  isShowModal = false;
  currentAudio: MusicAudioViewModel = null;
  categories: CategoryViewModel[] = [];
  coverImageRatio = COVER_IMAGE_RATIO;
  get title(): string {
    return this.id ? "Редактирование музыки" : "Добавление музыки";
  }
  get id(): number {
    const routeId = this.$route.params.id;
    return routeId ? Number(routeId) : 0;
  }
  vm: CreateMusicViewModel = new CreateMusicViewModel();
  async created() {
    this.languages = await this.$cacheProvider.getLanguagesAsync();
    this.vm.initLanguages(this.languages);
    const catRes = await this.$api.MusicService.getCategoriesAsync();
    this.categories = (catRes.Items || []).map((x) => new CategoryViewModel(x));
    if (this.$route.params.id) {
      await this.fetchData();
    }
  }
  async fetchData() {
    this.isLoading = true;
    try {
      const res = await this.$api.MusicService.getDetailAlbumAsync(this.id);
      const serverLanguages = [
        ...(res.AlbumTranslations || []).map((item) => item.LangCode),
        ...(res.Audiofiles || []).flatMap((audio) =>
          (audio.AudiofileTranslations || []).map((item) => item.LangCode)
        )
      ].filter(Boolean);
      this.languages = this.mergeLanguages(this.languages, serverLanguages);
      this.vm.initLanguages(this.languages);
      this.vm.fromServerModel(res);
    } catch (error) {
      this.$notification.error(error);
    } finally {
      this.isLoading = false;
    }
  }
  async save() {
    if (!this.hasAtLeastOneTranslation()) {
      this.$notification.error("Заполните хотя бы один перевод");
      return;
    }
    const isValid = (this.$refs.validator as any).isValid();
    if (!isValid) return;
    this.isLoading = true;
    try {
      if (!this.vm.hasCoverImage) {
        this.$notification.error("Добавьте обложку");
        return;
      }
      await Promise.all([
        ...this.vm.audios.map(audio => audio.ensureAudioFileReady())
      ]);
      const request = this.vm.toServerModel();
      const res = await this.$api.MusicService.updateAlbumAsync(request);
      if (res) {
        this.$dialog.success(
          this.id ? "Музыка успешно обновлена" : "Музыка успешно добавлена"
        );
        this.$router.back();
      }
    } catch (error) {
      this.$notification.error(error);
    } finally {
      this.isLoading = false;
    }
  }
  mergeLanguages(baseLanguages: string[], extraLanguages: string[]): string[] {
    const languages = (baseLanguages || []).slice();
    const languageKeys = languages.map((langCode) => (langCode || "").toLowerCase());
    (extraLanguages || []).forEach((langCode) => {
      const normalizedLangCode = (langCode || "").toLowerCase();
      if (normalizedLangCode && normalizedLangCode !== "lv" && languageKeys.indexOf(normalizedLangCode) === -1) {
        languages.push(langCode);
        languageKeys.push(normalizedLangCode);
      }
    });
    return languages;
  }
  hasAtLeastOneTranslation(): boolean {
    return (this.vm.translations || []).some(
      (item) => Boolean((item.name || "").trim())
    );
  }
  audioChanged(audio: MusicAudioViewModel) {
    if (audio == null) {
      this.currentAudio = null;
      return;
    }
    if (this.audioAddMode == "edit") {
      Object.assign(this.currentAudio, audio);
    } else if (this.audioAddMode == "add") {
      if (this.vm.audios.length > 0) {
        this.$notification.error("Для альбома можно добавить только одно аудио");
        this.currentAudio = null;
        this.isShowModal = false;
        return;
      }
      this.vm.audios.push(audio);
    }
    this.currentAudio = null;
    this.isShowModal = false;
  }
  audioClose() {
    this.isShowModal = false;
  }
  audioAddMode: "edit" | "add" | null = null;
  startAddAudio() {
    if (this.vm.audios.length > 0) {
      return;
    }
    const audio = new MusicAudioViewModel();
    audio.initLanguages(this.languages);
    this.currentAudio = audio;
    this.audioAddMode = "add";
    this.isShowModal = true;
  }
  startEditAudio(item: MusicAudioViewModel) { 
    this.currentAudio = item;
    this.audioAddMode = "edit";
    this.isShowModal = true;
  }
  deleteAudio(item: MusicAudioViewModel) {
    this.vm.audios = this.vm.audios.filter((x) => x != item);
  }
}
